module.exports = __webpack_public_path__ + "static/media/upload_more.700a2ea0.svg";